<template>
  <div class="mqtt-test-container">
    <div class="header">
      <h2>MQTT PLC 读写测试</h2>
      <el-button type="primary" @click="testConnection">测试连接</el-button>
    </div>

    <!-- 快速操作区域：设置 vw2000=100 -->
    <el-card class="box-card" style="margin-top: 20px;">
      <div slot="header" class="clearfix">
        <span>快速操作 - VW2000 寄存器</span>
      </div>
      <div class="quick-action">
        <el-button 
          type="success" 
          @click="setVw2000To100" 
          :loading="vw2000Loading"
          size="medium">
          设置 VW2000 = 100
        </el-button>
        <el-button 
          type="primary" 
          @click="readVw2000" 
          :loading="readVw2000Loading"
          size="medium"
          style="margin-left: 10px;">
          读取 VW2000 当前值
        </el-button>
      </div>
      <div v-if="vw2000Result" class="result-box" style="margin-top: 15px;">
        <el-alert
          :title="vw2000Result.title"
          :type="vw2000Result.type"
          :description="vw2000Result.message"
          show-icon
          :closable="false">
        </el-alert>
      </div>
    </el-card>

    <el-card class="box-card" style="margin-top: 20px;">
      <div slot="header" class="clearfix">
        <span>读取PLC寄存器</span>
      </div>
      <el-form :inline="true" :model="readForm" class="demo-form-inline">
        <el-form-item label="从站ID (sid)">
          <el-input v-model="readForm.sid" placeholder="默认: 1" style="width: 150px;"></el-input>
        </el-form-item>
        <el-form-item label="寄存器地址 (pid)">
          <el-input v-model="readForm.pid" placeholder="例如: 0, 100, zyj1" style="width: 150px;"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="readRegister" :loading="readLoading">读取</el-button>
        </el-form-item>
      </el-form>
      <div v-if="readResult" class="result-box">
        <el-alert
          :title="readResult.title"
          :type="readResult.type"
          :description="readResult.message"
          show-icon
          :closable="false">
        </el-alert>
      </div>
    </el-card>

    <el-card class="box-card" style="margin-top: 20px;">
      <div slot="header" class="clearfix">
        <span>写入PLC寄存器</span>
      </div>
      <el-form :inline="true" :model="writeForm" class="demo-form-inline">
        <el-form-item label="从站ID (sid)">
          <el-input v-model="writeForm.sid" placeholder="默认: 1" style="width: 150px;"></el-input>
        </el-form-item>
        <el-form-item label="寄存器地址 (pid)">
          <el-input v-model="writeForm.pid" placeholder="例如: 0, 100, zyj1" style="width: 150px;"></el-input>
        </el-form-item>
        <el-form-item label="写入值 (value)">
          <el-input v-model="writeForm.value" placeholder="例如: 1, 0, 123" style="width: 150px;"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="success" @click="writeRegister" :loading="writeLoading">写入</el-button>
        </el-form-item>
      </el-form>
      <div v-if="writeResult" class="result-box">
        <el-alert
          :title="writeResult.title"
          :type="writeResult.type"
          :description="writeResult.message"
          show-icon
          :closable="false">
        </el-alert>
      </div>
    </el-card>

    <el-card class="box-card" style="margin-top: 20px;">
      <div slot="header" class="clearfix">
        <span>连接信息</span>
      </div>
      <el-descriptions :column="2" border>
        <el-descriptions-item label="MQTT服务器">tcp://yunchunremote.cn:1883</el-descriptions-item>
        <el-descriptions-item label="ClientId">01401425092000006407-0</el-descriptions-item>
        <el-descriptions-item label="用户名">liu</el-descriptions-item>
        <el-descriptions-item label="设备名称">木耳510</el-descriptions-item>
        <el-descriptions-item label="发布Topic">/usr/plcnet/木耳510/edge/d</el-descriptions-item>
        <el-descriptions-item label="订阅Topic">/usr/plcnet/木耳510/edge/u</el-descriptions-item>
      </el-descriptions>
    </el-card>
  </div>
</template>

<script>
import request from '@/utils/request'

const api = request

export default {
  name: 'MqttTest',
  data() {
    return {
      readForm: {
        sid: '1',
        pid: '0'
      },
      writeForm: {
        sid: '1',
        pid: '0',
        value: '1'
      },
      readLoading: false,
      writeLoading: false,
      readResult: null,
      writeResult: null,
      // VW2000 相关状态
      vw2000Loading: false,
      readVw2000Loading: false,
      vw2000Result: null
    };
  },
  methods: {
    // 快速设置 VW2000 = 100
    async setVw2000To100() {
      this.vw2000Loading = true;
      this.vw2000Result = null;
      
      try {
        const params = {
          sid: '1',
          pid: 'vw2000',
          value: '100'
        };
        
        const response = await api.post('/api/mqtt/write', null, { params });
        
        if (response.data.code === '200') {
          this.vw2000Result = {
            type: 'success',
            title: '设置成功',
            message: '已成功将 VW2000 寄存器设置为 100'
          };
          this.$message.success('VW2000 已设置为 100');
        } else {
          this.vw2000Result = {
            type: 'error',
            title: '设置失败',
            message: response.data.message || '未知错误'
          };
          this.$message.error('设置失败: ' + response.data.message);
        }
      } catch (error) {
        this.vw2000Result = {
          type: 'error',
          title: '设置失败',
          message: error.response?.data?.message || error.message || '网络错误'
        };
        this.$message.error('设置失败: ' + (error.response?.data?.message || error.message));
      } finally {
        this.vw2000Loading = false;
      }
    },
    
    // 读取 VW2000 当前值
    async readVw2000() {
      this.readVw2000Loading = true;
      this.vw2000Result = null;
      
      try {
        const params = {
          sid: '1',
          pid: 'vw2000'
        };
        
        const response = await api.get('/api/mqtt/read', { params });
        
        if (response.data.code === '200') {
          this.vw2000Result = {
            type: 'success',
            title: '读取成功',
            message: `VW2000 寄存器的当前值为: ${response.data.data}`
          };
          this.$message.success('VW2000 当前值: ' + response.data.data);
        } else {
          this.vw2000Result = {
            type: 'error',
            title: '读取失败',
            message: response.data.message || '未知错误'
          };
          this.$message.error('读取失败: ' + response.data.message);
        }
      } catch (error) {
        this.vw2000Result = {
          type: 'error',
          title: '读取失败',
          message: error.response?.data?.message || error.message || '网络错误'
        };
        this.$message.error('读取失败: ' + (error.response?.data?.message || error.message));
      } finally {
        this.readVw2000Loading = false;
      }
    },
    // 测试连接
    async testConnection() {
      try {
        const response = await api.get('/api/mqtt/test');
        if (response.data.code === '200') {
          this.$message.success('MQTT连接正常: ' + response.data.data);
        } else {
          this.$message.error('MQTT连接失败: ' + response.data.message);
        }
      } catch (error) {
        this.$message.error('连接测试失败: ' + (error.response?.data?.message || error.message));
      }
    },
    
    // 读取寄存器
    async readRegister() {
      if (!this.readForm.pid) {
        this.$message.warning('请输入寄存器地址');
        return;
      }
      
      this.readLoading = true;
      this.readResult = null;
      
      try {
        const params = {
          sid: this.readForm.sid || '1',
          pid: this.readForm.pid
        };
        
        const response = await api.get('/api/mqtt/read', { params });
        
        if (response.data.code === '200') {
          this.readResult = {
            type: 'success',
            title: '读取成功',
            message: `寄存器地址 ${this.readForm.pid} 的值为: ${response.data.data}`
          };
        } else {
          this.readResult = {
            type: 'error',
            title: '读取失败',
            message: response.data.message || '未知错误'
          };
        }
      } catch (error) {
        this.readResult = {
          type: 'error',
          title: '读取失败',
          message: error.response?.data?.message || error.message || '网络错误'
        };
      } finally {
        this.readLoading = false;
      }
    },
    
    // 写入寄存器
    async writeRegister() {
      if (!this.writeForm.pid) {
        this.$message.warning('请输入寄存器地址');
        return;
      }
      if (this.writeForm.value === '' || this.writeForm.value === null || this.writeForm.value === undefined) {
        this.$message.warning('请输入要写入的值');
        return;
      }
      
      this.writeLoading = true;
      this.writeResult = null;
      
      try {
        const params = {
          sid: this.writeForm.sid || '1',
          pid: this.writeForm.pid,
          value: this.writeForm.value
        };
        
        const response = await api.post('/api/mqtt/write', null, { params });
        
        if (response.data.code === '200') {
          this.writeResult = {
            type: 'success',
            title: '写入成功',
            message: `已向寄存器地址 ${this.writeForm.pid} 写入值: ${this.writeForm.value}`
          };
        } else {
          this.writeResult = {
            type: 'error',
            title: '写入失败',
            message: response.data.message || '未知错误'
          };
        }
      } catch (error) {
        this.writeResult = {
          type: 'error',
          title: '写入失败',
          message: error.response?.data?.message || error.message || '网络错误'
        };
      } finally {
        this.writeLoading = false;
      }
    }
  }
};
</script>

<style scoped>
.mqtt-test-container {
  padding: 20px;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.header h2 {
  margin: 0;
  color: #303133;
}

.box-card {
  margin-bottom: 20px;
}

.result-box {
  margin-top: 20px;
}

.demo-form-inline {
  margin-top: 10px;
}

.quick-action {
  margin-top: 10px;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}

.clearfix:after {
  clear: both;
}
</style>


